/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Flex from './Flex';

export const Pagination = ({
 canPreviousPage,
 canNextPage,
 previousPage,
 nextPage,
 /* pageCount, */
 pageIndex,
 gotoPage,
 paginationArray
}) => {
 //const pageTotal = pageCount - 1;
 //const files = Array.from(Array(pageCount > 7 ? 5 : pageCount < 3 ? 0 : pageCount - 2).keys());

 return (
  <Flex alignItems="center" justifyContent="center">
   <div>
    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: 'fixed' }}>Anterior</Tooltip>}>
     <Button
      variant="falcon-default"
      size="sm"
      onClick={() => previousPage()}
      disabled={!canPreviousPage}
      className="me-2"
      trigger="focus"
     >
      <FontAwesomeIcon icon="chevron-left" />
     </Button>
    </OverlayTrigger>
   </div>

   <ul className="pagination mb-0">
    {paginationArray
     .filter(e => {
      if (paginationArray.length > 7) return e < 6;
      else if (paginationArray.length < 3) return e < 2;
      else return e <= paginationArray.length - 1;
     })
     .map(page => {
      const pgCount = paginationArray.length - 5;
      const pageNum = page < 1 ? pageIndex - page : page > 1 ? pageIndex + page - 1 : pageIndex;

      //   console.log({ page, pageIndex, pageNum, pgCount, paginationArray }, paginationArray.length);

      if (pageIndex >= pgCount && paginationArray.length > 7) {
       let pgNum = page < 2 ? pgCount - page : page > 2 ? pgCount + page - 1 : pgCount;
       if (pageIndex === pgCount) pgNum = pageNum;

       return (
        <li key={page} className={classNames({ active: pageIndex === pgNum })}>
         <Button size="sm" variant="falcon-default" className="page me-2" onClick={() => gotoPage(pgNum)} disabled={page < 1}>
          {page < 1 ? <FontAwesomeIcon icon="ellipsis-h" className="text-success fs--2 align-bottom" /> : pgNum}
         </Button>
        </li>
       );
      } else if (pageIndex > 4 && paginationArray.length > 7)
       return (
        <li key={page} className={classNames({ active: pageIndex === pageNum })}>
         <Button
          size="sm"
          variant="falcon-default"
          className="page me-2"
          onClick={() => gotoPage(pageNum)}
          disabled={/0|5/.test(page)}
         >
          {/0|5/.test(page) ? <FontAwesomeIcon icon="ellipsis-h" className="text-success fs--2 align-bottom" /> : pageNum}
         </Button>
        </li>
       );
      else if (paginationArray.length > 7)
       return (
        <li key={page} className={classNames({ active: pageIndex === page })}>
         <Button size="sm" variant="falcon-default" className="page me-2" onClick={() => gotoPage(page)} disabled={page === 5}>
          {page === 5 ? <FontAwesomeIcon icon="ellipsis-h" className="text-success fs--2 align-bottom" /> : page}
         </Button>
        </li>
       );

      return (
       <li key={page} className={classNames({ active: pageIndex === page })}>
        <Button size="sm" variant="falcon-default" className="page me-2" onClick={() => gotoPage(page)}>
         {page}
        </Button>
       </li>
      );
     })}

    {paginationArray.length > 1 && (
     <li className={classNames({ active: pageIndex === paginationArray.length })}>
      <Button size="sm" variant="falcon-default" className="page me-2" onClick={() => gotoPage(paginationArray.length)}>
       {paginationArray.length}
      </Button>
     </li>
    )}
   </ul>

   <div>
    <OverlayTrigger
     trigger="click"
     placement="top"
     overlay={
      <Tooltip style={{ position: 'fixed' }} id="button-tooltip-2">
       Next
      </Tooltip>
     }
    >
     <Button variant="falcon-default" size="sm" disabled={!canNextPage} onClick={nextPage} trigger="focus">
      <FontAwesomeIcon icon="chevron-right" />
     </Button>
    </OverlayTrigger>
   </div>
  </Flex>
 );
};

export default Pagination;
